<template>
    <div class="home-view">
        <Topbar />

        <div class="container-fluid text-left pl-2 pr-2 d-flex justify-content-center mt-5 pt-2">
          <div class="shadow col-md-6 m-0 p-0 text-secondary">
            <div class="card small">
              <div class="card-header text-white text-center p-1" :style="{ backgroundColor: moduloAtual().color }">
                  CONSULTA PRODUTO
                  <div v-show="carregando" class="spinner-grow">
                    <span class="sr-only">Loading...</span>
                  </div>
              </div>
              <div class="card-body p-2">
                <div class="mt-2 small">
                  <select class="form-control form-control-sm mb-1" id="cliente">
                    <option value="">-- SELECIONE O CLIENTE --</option>
                    <option v-for="option in clientes" :value="option.id" :key="option.id">
                      {{ option.fantasia }} - {{ option.id }}
                    </option>
                  </select>
                  
                  <InputDefaultApp
                      key="produtoInput"
                      idInput="produtoInput"
                      inputPlaceHolderSufixo="Digite código de barras do produto"
                      titleScan="Escanear Produto"
                      typeInputMode="text"
                      @displayScanFunction="buscarProduto"
                      :enterKey="(e) => buscarProduto(e.target.value)"
                      :errorMessage="this.produtoErrorMessage"
                      :toUpperCase="true"
                  />
                  </div>
              </div>
            </div>
            <div class="card small mt-2" v-if="this.produtosEncontrados">
              <div class="card-header p-0 bg-secondary text-white text-center">
                Produtos Encontrados
              </div>
              <div class="card-body p-2 small" style="height: 210px; overflow-y: auto; overflow-x: hidden;">
                <table class="table table-striped table-bordered small" v-if="this.produtosEncontrados.length > 0">
                  <caption class="d-none"></caption>
                  <thead>
                    <tr>
                      <th class="p-1">Produto</th>
                      <th class="p-1">Saldo</th>
                      <th class="p-1">Cod.Barras</th>
                      <th class="text-center p-1">Detalhes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item) in this.produtosEncontrados" :key="item.idprodutos">
                      <td class="p-1">{{ item.descricao }}</td>
                      <td class="p-1">{{ item.saldo }}</td>
                      <td class="p-1">{{ item.codbarras }}</td>
                      <td class="text-center p-1">
                        <router-link class="btn btn-sm btn-success" :to="{ name: 'ConsultaProdutoResultado', params: { idproduto: item.idprodutos } }">
                          <em class="fa fa-align-justify"></em>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center" v-if="this.produtosEncontrados.length === 0">
                  <br>
                  <span class="text-secondary">NENHUM RESULTADO ENCONTRADO!</span>
                  <br>
                  <br>
                  <em class="fa fa-frown-open fa-3x mb-2"></em>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-secondary mt-4" v-if="!this.produtosEncontrados">
          <em class="fa fa-info-circle fa-3x mb-2"></em>
          <br>
          <span class="small">
            <span class="font-weight-bold text-secondary">
                Opções de busca dos produtos:
            </span>
            <br>
            1.Código de barras
            <br>
            2. SKU
            <br>
            3. Descrição!
          </span>
        </div>
        <LogoutModal />
        <FooterBar />
    </div>
</template>

<script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import FooterBar from '@/components/FooterBar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import InputDefaultApp from '../components/InputDefaultApp.vue';
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { getUsername, getPerfil } from '../services/api'
  import $ from "jquery"
  import audioService from '@/services/audioService.js';

  export default {
    name: 'ConsultaProdutos',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      InputDefaultApp
    },
  
    data: () => {
      return {
        produtosEncontrados: null,
        produtoErrorMessage: null,
        clientes: [],
      };
    },
  
    async mounted() {
      try {
        await this.validarToken();
        await this.listarClientes();
        
        $("#cliente").change(() => {
          $("#produtoInput").focus();
        });

        $("#produtoInput").focus();
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
      getUsername,
      getPerfil,
      playSound() {
        audioService.ops();
      },

      async validarToken() {
        this.carregando = true;
  
        await api.get("/validar-token");
  
        this.carregando = false;
      },

      async listarClientes() {
        this.carregando = true;
        this.clientes = [];
        
        try {
            let response = await api.get(`/cliente/listar`);
            response.data.forEach((e) => {
                this.clientes.push(e)
            }, this);

            setTimeout(() => {
                $("#enderecoInput").focus();
            }, 500);
        } catch (e) {
            console.error(e);
            this.playSound();
        }
        this.carregando = false;
      },

      async buscarProduto(codigoBarras) {

        if ($("#cliente").val() === "") {
          this.produtoErrorMessage = 'Por favor selecione o cliente!';
          this.playSound();
          return;
        }

        if (codigoBarras.trim() === "") {
          this.produtoErrorMessage = 'Por favor informe o produto!';
          this.playSound();
          return;
        }

        this.carregando = true;

        try {
          let result = await api.post("/pesquisa/produtos/buscar", {
            pesquisa: codigoBarras,
            idCliente: $("#cliente").val()
          });

          this.produtosEncontrados = result.data;

          if (this.produtosEncontrados.length === 0) {
            this.produtoErrorMessage = "Nenhum resultado encontrado!";
            this.playSound();
          }

          $("#produtoInput").focus();
          $("#produtoInput").select();
          this.produtoErrorMessage = null
        } catch (error) {
          this.produtoErrorMessage = error.message;
          $("#produtoInput").focus();
          $("#produtoInput").select();
          this.playSound();
        }

        this.carregando = false;
      },
    },
  }
  </script>
  
  <style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }
  
    .container-img {
      height: auto;
      display: flex;
      justify-content: center;
      align-self: center;
    }

  </style>
  